import Loadable from 'react-loadable';
import Loading from '../Loading';

export default Loadable({
  loader: () =>
    import(/* webpackChunkName: "DateTimePicker" */ '../../components/common/DateTimePicker'),
  loading: Loading(),
});
